import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GraphData } from '../../interfaces/graph-data.model';
import { Program } from '../../interfaces/program.model';

@Component({
  selector: 'app-program-card',
  templateUrl: './program-card.component.html',
  styleUrls: ['./program-card.component.scss']
})
export class ProgramCardComponent implements OnInit, OnChanges {
  @Input() program: Program;

  data: GraphData[];
  financeVisible: boolean = false;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    this.data = this.createGraphData();
  };

  ngOnInit() {
    this.data = this.createGraphData();
  }

  createGraphData() {
     return [
      {
        value: this.program.realised,
        color: '#ff9800',
        name: 'Realisatie'
      },
      {
        value: this.program.forecast,
        color: '#003277',
        name: 'Prognose'
      },
      {
        value: this.program.space,
        color: '#D2E6E8',
        name: 'Saldo'
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/components/program-card/program-card.component.ts